import { customerMarketShopfrontJobsApi } from '@envato/foundation-types'
import axiosVerbose from '../../utils/axios/axiosVerbose'
import { ThunkAction } from 'redux-thunk'

import { IRootState } from '../../reducers'
import { logError } from '../../utils/errors'
import { hasFeature } from '../../utils/features'
import { getAllItemsIds, limitItemsForNewDesign } from '../../utils/item'
import { getBookmarksForItems } from '../user/bookmark'

export enum TypeKeys {
  GET_NEWEST_ITEMS_BY_CATEGORY_PENDING = 'GET_NEWEST_ITEMS_BY_CATEGORY_PENDING',
  GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS = 'GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS',
  GET_NEWEST_ITEMS_BY_CATEGORY_FAIL = 'GET_NEWEST_ITEMS_BY_CATEGORY_FAIL'
}

interface IPendingPayload {
  readonly category: string
}

interface ISuccessPayload {
  readonly category: string
  readonly searchResults: Readonly<
    customerMarketShopfrontJobsApi.INewestItemsResult
  >
}

export interface IGetNewestItemsByCategoryPendingAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
  readonly payload: IPendingPayload
}

export interface IGetNewestItemsByCategorySuccessAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
  readonly payload: ISuccessPayload
}

export interface IGetNewestItemsByCategoryFailAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
}

export type ActionTypes =
  | IGetNewestItemsByCategoryPendingAction
  | IGetNewestItemsByCategorySuccessAction
  | IGetNewestItemsByCategoryFailAction

export const fetchNewestItemsByCategory = (
  category: string
): ThunkAction<
  Promise<
    IGetNewestItemsByCategorySuccessAction | IGetNewestItemsByCategoryFailAction
  >,
  IRootState,
  any
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common
    const { location } = getState().router
    const { experiments } = getState()

    dispatch({
      payload: { category },
      type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
    })
    const categoryName = category === 'all' ? 'index' : category
    const newestItemPath = `shopfront-api/newest_items_by_category/${currentSite}/${categoryName}`
    return axiosVerbose
      .get<customerMarketShopfrontJobsApi.INewestItemsResult>(newestItemPath)
      .then(response => {
        const isRedesign = hasFeature(
          'homepageNewDesign',
          currentSite,
          location,
          experiments
        )
        const data: any = isRedesign
          ? limitItemsForNewDesign({
              newest_items: response.data
            }).newest_items
          : response.data

        const successAction: IGetNewestItemsByCategorySuccessAction = {
          payload: { searchResults: data, category },
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
        }

        if (isRedesign) {
          const itemIdsForBookmarks = getAllItemsIds({
            newest_items: data
          })
          dispatch(getBookmarksForItems(itemIdsForBookmarks))
        }

        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const failAction: IGetNewestItemsByCategoryFailAction = {
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
        }
        return dispatch(failAction)
      })
  }
}
